module.exports = __webpack_public_path__ + "static/media/email.e1c72400.gif";